import React from 'react'
import IKImageWrapper from '../IKImageWrapper'
import backimg from '../../images/foodi-footer.png'
import styles from '../Wrappers/MenuWrapper.module.scss'

export default function MenuIntroCard({ menu, onSelect, title, coverImage }) {
	const displayTitle = title || menu?.name
	const cover = menu?.cover || coverImage

	const handleActivate = () => {
		if (typeof onSelect === 'function') {
			onSelect(menu)
		}
	}

	return (
		<div
			className={styles.menu}
			onClick={handleActivate}
			onKeyDown={(e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault()
					handleActivate()
				}
			}}
			role="button"
			tabIndex={0}
			aria-label={displayTitle}
		>
			{cover ? (
				<IKImageWrapper
					image={cover}
					transformation={[{ width: 300, height: 450 }]}
					loading="lazy"
					lqip={{ active: true }}
					alt={displayTitle}
				/>
			) : (
				<img src={backimg} alt={displayTitle} />
			)}
			<div className={styles.menuContent}>
				<h3>{displayTitle}</h3>
			</div>
		</div>
	)
}
